import { useState } from "react";
import { Banknote } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api, inr, formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { Panel, StatusBadge } from "./common";
import { FormDialog } from "./FormDialog";

const today = () => new Date().toISOString().slice(0, 10);

export function PaymentBatches({ batches, canPay, onPaid }) {
  const [payFor, setPayFor] = useState(null);
  if (!batches.length) return null;
  const pay = async (f) => {
    try {
      const { data } = await api.post(`/payment-batches/${payFor.id}/pay`, f);
      toast.success(`Batch ${data.id} marked paid: ${data.paid_count} bill(s)`, { description: `Vendor payment receipts are being emailed.${data.skipped ? ` ${data.skipped} bill(s) were already paid or no longer approved.` : ""}` });
      onPaid();
      return true;
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); return false; }
  };
  return (
    <Panel testid="payment-batches-panel" title="Payment batches">
      {batches.slice(0, 8).map((b) => (
        <div key={b.id} data-testid={`batch-row-${b.id}`} className="flex flex-wrap items-center justify-between gap-3 border-b border-zinc-100 py-2.5 text-sm last:border-0">
          <div>
            <div className="font-semibold text-zinc-900">{b.id}</div>
            <div className="text-xs text-zinc-500">{b.count} bills · {b.projects.join(", ")} · exported {b.created_at.slice(0, 10)} by {b.created_by}</div>
          </div>
          <div className="flex items-center gap-3">
            <div className="text-right"><div className="font-semibold text-zinc-900">{inr(b.total)}</div>
              {b.status === "Paid" && <div className="text-[11px] text-zinc-400">{b.payment_date} · {b.payment_reference}</div>}</div>
            <StatusBadge testid={`batch-status-${b.id}`} value={b.status} />
            {b.status !== "Paid" && canPay && <Button data-testid={`batch-pay-${b.id}`} size="sm" variant="outline" onClick={() => setPayFor(b)}><Banknote className="h-3.5 w-3.5 mr-1" />Mark batch paid</Button>}
          </div>
        </div>
      ))}
      <FormDialog testid="batch-pay-form" open={!!payFor} onOpenChange={(o) => !o && setPayFor(null)} title={`Mark ${payFor?.id} paid`} submitLabel={`Mark ${payFor?.count || ""} bills paid`} initial={{ payment_date: today() }}
        fields={[{ name: "payment_date", label: "Payment date", type: "date", required: true }, { name: "payment_reference", label: "Bank reference (UTR / batch ref)", required: true }]} onSubmit={pay} />
    </Panel>
  );
}
